var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skill-items-preview" },
    _vm._l(_vm.skills, function (skillItems, skill) {
      return _c(
        "div",
        { key: skill, staticClass: "skill-items-list" },
        [
          _c("div", { staticClass: "skill-preview" }, [_vm._v(_vm._s(skill))]),
          _vm._v(" "),
          _vm._l(skillItems, function (skillItem, index) {
            return _c(
              "div",
              { key: index, staticClass: "skill-item-preview ms-2" },
              [
                skillItem.name != "prompt_ref"
                  ? [_vm._v("\n        " + _vm._s(skillItem.name) + "\n      ")]
                  : _vm._e(),
              ],
              2
            )
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }